import React from "react";
import clsx from "clsx";
import { useNavigate, useLocation } from "react-router-dom";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Tooltip from "@material-ui/core/Tooltip";
import CssBaseline from "@material-ui/core/CssBaseline";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { useStyles } from "./SidebarStyles";

import DashboardIcon from '@material-ui/icons/Dashboard';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import PeopleIcon from '@material-ui/icons/People';
import SchoolIcon from '@material-ui/icons/School';
import SubscriptionsIcon from '@material-ui/icons/Subscriptions';

export default function Sidebar({ open, setHeaderText }) {
  const navigate = useNavigate();
  const classes = useStyles();
  const location = useLocation();
  const pathName = location.pathname;

  const menuItems = [
    {
      name: "Dashboard",
      route: "/admin/dashboard",
      icon: <DashboardIcon />,
    },
    {
      name: "Admin",
      route: "/admin/administrator",
      icon: <SupervisorAccountIcon />,
    },
    {
      name: "Users",
      route: "/admin/user",
      icon: <PeopleIcon />,
    },
    {
      name: "Course",
      route: "/admin/course",
      icon: <SchoolIcon />,
    },
    {
      name: "Subscription",
      route: "/admin/subscription",
      icon: <SubscriptionsIcon />,
    },
  ];

  const activeIndex = menuItems.findIndex(item => item.route === pathName);

  React.useEffect(() => {
    if (activeIndex !== -1) {
      setHeaderText(menuItems[activeIndex].name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathName]);

  const onButtonClick = (index, text, path) => {
    setHeaderText(text);
    navigate(path);
  };

  const renderMenuList = () => (
    <List>
      {menuItems.map((item, index) => {
        const isActive = index === activeIndex;
        return (
          <ListItem
            button
            key={item.name}
            className={clsx(
              classes.listItem,
              isActive && classes.menuSelected
            )}
            onClick={() => onButtonClick(index, item.name, item.route)}
          >
            <Tooltip title={item.name}>
              <ListItemIcon className={isActive ? classes.iconSelected : classes.icon}>
                {item.icon}
              </ListItemIcon>
            </Tooltip>
            <ListItemText
              primary={item.name}
              classes={{
                primary: isActive
                  ? classes.menuTextSelected
                  : classes.menuText,
              }}
            />
          </ListItem>
        );
      })}
    </List>
  );

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, classes.sectionDesktop, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        {renderMenuList()}
      </Drawer>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, classes.sectionMobile, {
          [classes.drawerClose]: true,
        })}
        classes={{
          paper: clsx({
            [classes.drawerClose]: true,
          }),
        }}
      >
        {renderMenuList()}
      </Drawer>
    </div>
  );
}
